import moment from "moment";
import React from "react";
import { useState } from "react";
import { Eye, Download } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/menu/Loader";
import { fetchAppFileDoc, resetIsDownloaded } from "../../../stores/slices/document/documentDownloadSlice";
import { fetchAppDocList, resetApplicationsDocLists } from "../../../stores/slices/document/documentListSlice";
import { fetchAppFileRegenerateDoc, resetIsRegDownloaded } from "../../../stores/slices/document/regenerateDocumentSlice";
import Tooltip from "../../../components/btooltip/Tooltip";
import { getAllSessions } from "../../../utilities/API/supertokenServices";

function Correspondence() {
    const dispatch = useDispatch()
    const correspondence = useSelector((state) => state.documentListSlice);
    const applicationData = useSelector((state)=> state.appViewDetailsSlice);
    const loginData = useSelector((state)=> state.loginSlice);
    const sessionData = useSelector((state) => state.sessionSlice)
    const docDownloadData = useSelector((state) => state.documentDownloadSlice)
    const regDocDownloadData = useSelector((state) => state.regenerateDocumentSlice)
    const [loader, setLoader] = useState(false);

  const refreshList = () =>{
    dispatch(resetApplicationsDocLists());
    let data = {
      portalUserID:loginData.value.PortalUserID,
      applicationID:applicationData.viewAppInfo.applicationId,
      EmailAddress:loginData.value.EmailAddress,
      ReferenceID:loginData.value.EIN,
    }
    dispatch(fetchAppDocList
        ({appData: data, prgData: applicationData.program}))
  }
  const resetLoader = () =>{
    setLoader(false)
    dispatch(resetIsDownloaded())
    dispatch(resetIsRegDownloaded())
    refreshList()
  }
  regDocDownloadData.isDownloaded && resetLoader()
  docDownloadData.isDownloaded && resetLoader()

  const downloadDoc = ( data ) =>{
    setLoader(true)
    if(data.pyCategory == 'URL'){
           const cURL = data.BrowserUrl;        
           const fileName = data.FileName;
           fetch(cURL, {
             method: 'GET',
             // headers: {
             //   'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
             //   'Ocp-Apim-Trace': API_TRACE
             // }
           }).then(function(t) {
             return t.blob().then((b)=>{
               var a = document.createElement("a");
               a.href = URL.createObjectURL(b);
               a.setAttribute("download", fileName);
               a.click();
               setLoader(false)
               refreshList()
             });
           });
    }else{
            dispatch(fetchAppFileDoc({DocumentID:data.pzInsKey,prgData:applicationData.program, reqstData: data}))
    }
   
  }

  const regenerate = (prop) =>{
    setLoader(true)
    let docDownload={
        ApplicationID:applicationData.viewAppInfo.applicationId,
        PreferredLanguage:prop.PreferredLanguage == 'Spanish' ? 'English' : 'Spanish',
        PreferredContact: prop.CorrPreferences,
        RegenerateLetter: prop.TemplateName,
        PortalID:loginData.value.PortalUserID
    }
        dispatch(fetchAppFileRegenerateDoc({doc:docDownload,prgData:applicationData.program, reqstData: prop}))
  }

  return (
    <div>
      {loader && <Loader />}
      <div class="intro-y box mt-5">
        <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
          <h2 class="fw-medium fs-base me-auto">Correspondence</h2>
        </div>
        <table className="table table-report mt-sm-2">
          <thead>
            <tr>
              <th className="text-center text-nowrap display">
                Correspondence
              </th>
              <th className="text-center text-nowrap">Received On</th>
              <th className="text-center text-nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(correspondence.corrList).map((key) => {
              if (key != "PhysicianForm") {
                let outputData =
                  correspondence.corrList[key].ARR[0].pxCreateDateTime;
                let splitDate = outputData.substring(0, 10);
                let dateformat = moment(splitDate).format("ll");
                return (
                  <tr className="intro-x">
                    <td className="display text-center">
                      <b>
                        {key}
                      </b>
                    </td>
                    <td className="text-center">{dateformat}</td>
                    <td className="table-report__action w-30">
                      <div className="d-flex justify-content-center align-items-center">
                        {}
                        {correspondence.corrList[key].ARR.length < 2 ? (
                          correspondence.corrList[key].ARR[0].pyCategory ==
                          "File" ? (
                            <button onClick={()=>{downloadDoc(correspondence.corrList[key].ARR[0])}} className=" btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white">
                              <div className="h-15">
                                <Download />
                              </div>
                            </button>
                          ) : (
                            <>
                                <Tooltip content= {'Download Attachment - '+correspondence.corrList[key].ARR[0].PreferredLanguage}>
                                    <button onClick={()=>{downloadDoc(correspondence.corrList[key].ARR[0])}} className=" btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white">
                                      <div className="h-15">
                                        <Download />
                                      </div>
                                      {correspondence.corrList[key].ARR[0].PreferredLanguage == 'English' ? 'E' : 'S'}
                                    </button>
                                </Tooltip>
                                <Tooltip content= {correspondence.corrList[key].ARR[0].PreferredLanguage == 'English' ? 'Download Attachment - Spanish' : 'Download Attachment - English'}>
                                    <button onClick={()=>{regenerate(correspondence.corrList[key].ARR[0])}} className=" btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white">
                                      <div className="h-15">
                                        <Download />
                                      </div>
                                      {correspondence.corrList[key].ARR[0].PreferredLanguage == 'English' ? 'S' : 'E'}
                                    </button>
                                </Tooltip>
                            </>
                          )
                        ) : (
                            correspondence.corrList[key].ARR[0].pyCategory ==
                            "File" ? (
                              <button onClick={()=>{downloadDoc(correspondence.corrList[key].ARR[0])}} className=" btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white">
                                <div className="h-15">
                                  <Download />
                                </div>
                              </button>
                            ) : (
                              <>
                                  <Tooltip content= {'Download Attachment - '+correspondence.corrList[key].ARR[0].PreferredLanguage}>
                                    <button onClick={()=>{downloadDoc(correspondence.corrList[key].ARR[0])}} className=" btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white">
                                      <div className="h-15">
                                        <Download />
                                      </div>
                                      {correspondence.corrList[key].ARR[0].PreferredLanguage == 'English' ? 'E' : 'S'}
                                    </button>
                                  </Tooltip>
                                  <Tooltip content= {correspondence.corrList[key].ARR[0].PreferredLanguage == 'English' ? 'Download Attachment - Spanish' : 'Download Attachment - English'}>
                                    <button onClick={()=>{downloadDoc(correspondence.corrList[key].ARR[1])}} className=" btn d-flex align-items-center me-3  bg-theme-9 cursor-pointer txt-white">
                                      <div className="h-15">
                                        <Download />
                                      </div>
                                      {correspondence.corrList[key].ARR[0].PreferredLanguage == 'English' ? 'S' : 'E'}
                                    </button>
                                  </Tooltip>
                              </>
                            )
                          )}
                      </div>
                    </td>
                  </tr>
                );
              }
            })}

            {/* {appList.map((data)=>{
                                return(
                                    <tr className="intro-x">
                                    <td className='display text-center'>
                                        <a href="" className="fw-medium text-nowrap">{data.program}</a>
                                    </td>
                                    <td className="text-center">{data.applicationID}</td>
                                    <td className="w-40">
                                    <div class={`py-1 px-5 g-col-5 rounded-pill fs-xs ${data.status =='Denied' ? `bg-theme-6` : data.status =='Pending' ? `bg-yellow`: data.status =='Approved' ? `bg-theme-9`: `bg-default` } text-white cursor-pointer fw-medium text-center`}>{data.status} </div>
                                    </td>
                                    <td className="table-report__action w-30">
                                        <div className="d-flex justify-content-center align-items-center">
                                            <a className="d-flex align-items-center me-3"><div className='h-15 p-2'> <Eye /></div>{selectedLanguage.view} </a>
                                        </div>
                                    </td>
                                </tr>
                                )
                            })} */}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Correspondence;
